import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "max-mobile-width" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "form-check mt-3" }
const _hoisted_7 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_8 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-center mb-4 mt-4" }, [
          _createElementVNode("img", { src: 'img/logo.png' })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "login-ic" }, "IČ dopravce", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "login-ic",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ic) = $event))
            }, null, 512), [
              [_vModelText, _ctx.ic]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "login-pin" }, [
              _createTextVNode("PIN "),
              _createElementVNode("span", {
                class: "k-icon k-i-question",
                id: "pinquestion",
                title: "PIN jsou poslední 4 číslice z čísla řidičského průkazu"
              })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "login-pin",
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pin) = $event))
            }, null, 512), [
              [_vModelText, _ctx.pin]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              id: "login-remember",
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remember) = $event)),
              class: "form-check-input align-middle"
            }, null, 512), [
              [_vModelCheckbox, _ctx.remember]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "login-remember",
              class: "form-check-label ms-2"
            }, "Zapamatovat přihlášení", -1))
          ]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-4 text-center" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary"
            }, "Přihlásit")
          ], -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mt-4 text-center bg-white credits" }, "ver. 1.0.1", -1))
        ])
      ])
    ], 32)
  ]))
}